export enum SurveyGetterEnum {
  SURVEYS = 'surveys'
}
